import { useIntl } from "react-intl";

import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import { predefinedFields } from "types/predefinedFields";
import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { FormItem as BaseFormItem, FormControl, FormField, FormLabel } from "uiShadcn/form";
import { RadioGroup, RadioGroupItem } from "uiShadcn/radio-group";

interface DriverLicenseProps {
    control: FormControlType;
    uiData: IFormInputs;
}

export default function DriverLicense({ control, uiData }: DriverLicenseProps) {
    const { formatMessage } = useIntl();
    const isRequired = uiData?.required?.includes("true");

    const dictionary = [
        { value: false, label: formatMessage({ id: "no" }) },
        { value: true, label: formatMessage({ id: "yes" }) },
    ];

    return (
        <Fieldset title={formatMessage({ id: "drivingLicense" })}>
            <FormField
                control={control}
                name={predefinedFields.drivingLicense}
                render={({ field }) => (
                    <FormItem label={formatMessage({ id: "driverLicenseQuestion" })} required={isRequired}>
                        <FormControl>
                            <RadioGroup
                                onValueChange={field.onChange}
                                defaultValue={field.value}
                                className="flex flex-col space-y-1"
                                dataTestId={field.name}
                                name={formatMessage({
                                    id: "drivingLicense",
                                })}
                                required={isRequired}
                            >
                                {dictionary?.map(({ value, label }) => (
                                    <BaseFormItem key={value.toString()} className="flex items-center gap-n2">
                                        <FormControl>
                                            <RadioGroupItem
                                                value={value.toString()}
                                                dataTestId={`${field.name}-${label}`}
                                                aria-label={label}
                                            />
                                        </FormControl>
                                        <FormLabel>{label}</FormLabel>
                                    </BaseFormItem>
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </FormItem>
                )}
            />
        </Fieldset>
    );
}
